import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

const LOCAL_KEY = 'sensestack_documents';

function loadLocal() {
  try {
    return JSON.parse(localStorage.getItem(LOCAL_KEY) || '[]');
  } catch {
    return [];
  }
}

function saveLocal(docs) {
  localStorage.setItem(LOCAL_KEY, JSON.stringify(docs));
}

function makeToken() {
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
}

export async function createDocument({ type, ownerId, clientEmail, clientName, data, status = 'draft' }) {
  const payload = { type, ownerId, clientEmail, clientName, data, status };

  try {
    const res = await axios.post(`${API}/documents`, payload);
    return res.data;
  } catch {
    const doc = {
      id: makeToken(),
      publicToken: makeToken(),
      type,
      ownerId,
      clientEmail,
      clientName,
      data,
      status,
      clientSignature: null,
      signedAt: null,
      paidAt: null,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
    const docs = loadLocal();
    docs.push(doc);
    saveLocal(docs);
    return doc;
  }
}

export async function listDocuments(ownerId) {
  try {
    const res = await axios.get(`${API}/documents`, { params: { ownerId } });
    return res.data.documents || [];
  } catch {
    return loadLocal().filter((d) => d.ownerId === ownerId);
  }
}

export async function getDocumentByToken(token) {
  try {
    const res = await axios.get(`${API}/documents/${token}`);
    return res.data;
  } catch {
    const doc = loadLocal().find((d) => d.publicToken === token || d.id === token);
    if (!doc) throw new Error('Document not found');
    return doc;
  }
}

export async function signDocument(token, { signerName, signatureData, signedContent, pdfDataUrl }) {
  try {
    const res = await axios.patch(`${API}/documents/${token}/sign`, {
      signerName,
      signatureData,
      signedContent,
      pdfDataUrl,
    });
    return res.data;
  } catch {
    const docs = loadLocal();
    const idx = docs.findIndex((d) => d.publicToken === token);
    if (idx === -1) throw new Error('Document not found');
    docs[idx] = {
      ...docs[idx],
      status: 'signed',
      clientSignature: signatureData,
      signerName,
      signedAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      data: {
        ...docs[idx].data,
        signedContent,
        pdfDataUrl,
        clientSignature: signatureData,
        signerName,
      },
    };
    saveLocal(docs);
    return docs[idx];
  }
}

export async function updateDocumentStatus(token, status) {
  try {
    const res = await axios.patch(`${API}/documents/${token}`, { status });
    return res.data;
  } catch {
    const docs = loadLocal();
    const idx = docs.findIndex((d) => d.publicToken === token);
    if (idx === -1) throw new Error('Document not found');
    docs[idx] = { ...docs[idx], status, updatedAt: new Date().toISOString() };
    saveLocal(docs);
    return docs[idx];
  }
}

export async function createStripeCheckout(token) {
  const res = await axios.post(`${API}/stripe-checkout`, { token });
  return res.data;
}

export function getPublicUrl(type, token) {
  const origin = window.location.origin;
  if (type === 'contract') return `${origin}/sign/${token}`;
  if (type === 'invoice') return `${origin}/pay/invoice/${token}`;
  if (type === 'timesheet') return `${origin}/timesheet/${token}`;
  return `${origin}/${token}`;
}
